<template>
  <div>
    <component 
      v-if="providerComponent && bookingData" 
      :is="providerComponent"
      :booking-data="bookingData"
    />
  </div>
</template>

<script>
import { _getBooking } from "@/services/Payment";
import InfocabPromotion from "./promotionNUDG/providers/InfocabPromotion.vue";
import AutocabPromotion from "./promotionNUDG/providers/AutocabPromotion.vue";
import iCabbiPromotion from "./promotionNUDG/providers/iCabbiPromotion.vue";

/**
 * Provider Configuration
 * 
 * To add a new provider:
 * 1. Create a new component in ./promotionNUDG/providers/YourProviderPromotion.vue
 * 2. Import it above (e.g., import YourProviderPromotion from "./promotionNUDG/providers/YourProviderPromotion.vue")
 * 3. Add it to the components object below
 * 4. Add the mapping here: 'providername': 'YourProviderPromotion'
 * 
 * The provider name should match what comes from the API (case-insensitive)
 */
const PROVIDER_MAP = {
  infocab: 'InfocabPromotion',
  autocab: 'AutocabPromotion',
  icabbi: 'iCabbiPromotion',
  // Add more providers here as needed:
  // 'newprovider': 'NewProviderPromotion',
};

// Default fallback provider (used when provider is not found in map)
const DEFAULT_PROVIDER = 'autocab';

export default {
  name: 'PromotionNUDG',
  components: {
    InfocabPromotion,
    AutocabPromotion,
    iCabbiPromotion,
    // Add new provider components here as you create them
  },
  data() {
    return {
      provider: null,
      providerComponent: null,
      bookingData: null,
      bid: this.$route.params.bid
    };
  },
  beforeMount() {
    document.documentElement.style.overflow = "hidden";
    this.$vs.loading();
    this.loadProvider();
  },
  methods: {
    loadProvider() {
      _getBooking(this.bid).then(
        (res) => {
          this.bookingData = res.data.obj;
          this.provider = res.data.obj.booking_provider;
          
          // Get provider name in lowercase for matching
          const providerName = this.provider ? this.provider.toLowerCase() : null;
          
          // Determine which provider component to use
          if (providerName && PROVIDER_MAP[providerName]) {
            // Use the mapped component
            this.providerComponent = PROVIDER_MAP[providerName];
          } else {
            // Fallback to default provider
            console.warn(`Provider "${this.provider}" not found, using default: ${DEFAULT_PROVIDER}`);
            this.providerComponent = PROVIDER_MAP[DEFAULT_PROVIDER];
          }
          
          // Keep loader open - provider component will handle closing it
        },
        (error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: (error.response && error.response.data && error.response.data.message) || "Failed to load booking",
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        }
      );
    }
  }
};
</script>

